import { render, staticRenderFns } from "./verhuistips.vue?vue&type=template&id=b18599cc"
import script from "./verhuistips.vue?vue&type=script&lang=js"
export * from "./verhuistips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports